import styled from "styled-components";

export const MainWarraper = styled.div`
  padding: 40px 90px 40px 90px;

  @media (max-width: 773px) {
    padding: 70px 50px 70px 50px;
  }
`;

export const MainContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
`;

export const ContainerCryptos = styled.div`
    display: flex;
    flex-direction: row;
    margin-top: 40px;
    align-items: center;
    gap: 90px;

    @media (max-width: 773px){
        flex-direction: row;
    }
`;

export const ContainerDevelopmentProcess = styled.div`
  /* margin-left: 90px; */
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  /* gap: 20px; */

  @media (max-width: 773px) {
    margin-left: 0px;
  }
`;

export const ContentCyptos = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;

  @media (max-width: 773px) {
    width: 2px;
    flex-direction: column;
    justify-content: center;

    img{
      width: 40px !important;
    }
  }
`;